<template>
    <fieldset id="trt-plan-selector">
        <legend>Choose Your Plan</legend>
        <p class="side-margin">{{ productName }} &mdash; lowest price in the US. You&rsquo;re charged today for the full plan you choose.</p>

        <div class="trt-plans side-margin" style="display: flex; flex-direction: column-reverse">
            <label v-for="plan in plans" :key="plan.key" class="trt-plan" :class="{ 'trt-plan--active': selected === plan.key }">
                <input type="radio" name="trt_plan" :value="plan.key" v-model="selected" required />
                <strong>${{ plan.monthly }}</strong> &mdash; {{ plan.label }}
                <i>{{ plan.sub }}</i>
            </label>
        </div>

        <div class="trt-plan-summary side-margin" v-if="current">
            <span class="trt-plan-summary__today">Charged today: <strong>${{ current.total }}</strong></span>
            <span class="trt-plan-summary__note">{{ current.note }}</span>
        </div>
    </fieldset>
</template>

<script>
import { EventBus } from './event-bus.js';

export default {
    props: {
        initialPlan: {
            type: String,
            default: 'monthly',
        },
        productId: {
            type: String,
            default: '',
        },
        productName: {
            type: String,
            default: 'Testosterone Cypionate',
        },
    },
    data() {
        return {
            plans: [
                { key: 'annual',   monthly: 79, total: 948, label: '12 month supply', sub: 'Billed $948 today (best value)', note: '$79/mo x 12 charged today. Two 6-month vial shipments over the year.' },
                { key: 'biannual', monthly: 89, total: 534, label: '6 month supply',  sub: 'Billed $534 today',              note: '$89/mo x 6 charged today. One 6-month vial shipment.' },
                { key: 'monthly',  monthly: 99, total: 198, label: 'Month to month',  sub: '2-month minimum — billed $198 today, then $99/mo', note: '$99 x 2 today (2-month minimum), then $99/month. A vial ships every 60 days. Cancel anytime.' },
            ],
            selected: this.initialPlan,
        };
    },
    computed: {
        current() {
            return this.plans.find(plan => plan.key === this.selected) || null;
        },
    },
    watch: {
        selected() {
            this.broadcastPlan();
        },
    },
    mounted() {
        EventBus.$on('trtPlanRequest', () => this.broadcastPlan());
        this.broadcastPlan();
    },
    methods: {
        broadcastPlan() {
            const plan = this.current;
            EventBus.$emit('trtPlanChanged', {
                key: plan ? plan.key : null,
                total: plan ? plan.total : null,
                productId: this.productId,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/TrtPlanSelector.vue